// extracted by mini-css-extract-plugin
export default {"container":"nN-z","title":"oN-z","link":"pN-z"};